export default __webpack_public_path__ + "static/media/sizerpro-logo-white.05a5e5b7.png";